// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","976":"c16184b3"}[chunkId] + "-" + {"218":"e621e77ada0cb06563c8","532":"798a62fd7f3158f65d26","691":"dca34695437d5c7fbd9d","976":"68c7f49bb83ffff3dc73"}[chunkId] + ".js";
};